import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_GETDIRECTIONS = 'ddc.link.getDirections';

function getDirections({ currentTarget: element, timeStamp }) {
	let eventObject;
	const $element = $(element);
	const widgetName = $element
		.closest('[data-widget-name]')
		.attr('data-widget-name');

	if (
		!eventHasRun(DDC_LINK_GETDIRECTIONS, {
			timeStamp
		}) &&
		// Only track the event when the form has passed validation
		(!$element.data('validator') ||
			$element.data('validator').checkValidity())
	) {
		eventObject = {
			eventType: DDC_LINK_GETDIRECTIONS,
			eventData: {
				linkText: $element.find('button[type="submit"]').text().trim(),
				// Anchor-based directions links (e.g. the map-dynamic
				// "Visit us at" address link, US2046696) have no submit button;
				// expose the anchor's own text and its widget so consumers can
				// build a granular payload. Additive — existing form-based
				// directions consumers are unaffected.
				...($element.is('a') && { text: $element.text().trim() }),
				...(widgetName && { widgetName }),
				element
			}
		};
	}

	return eventObject;
}

export default getDirections;
